export default __webpack_public_path__ + "images/8dea75515aebf58cc0394c2ec6fe5e40-bg-05.jpg";